import React  , {  useState } from 'react';
import { DialogComponent, Spinner } from '../../../../../Components';
import { DeleteInquiryService   } from '../../../../../Services' ; 
import { showSuccess  , showError  } from '../../../../../Helper' ; 
import { useTranslation } from 'react-i18next';

export const DeleteInquiryDialog = ({
  parentTranslationPath,
  translationPath,
  close,
  onSave , 
  activeItem, 
}) => {

  const { t } = useTranslation('Inquires');
  const [isLoading , setIsLoading ] = useState(false) ; 

  const deleteHandler = async () => {
    setIsLoading(true);
    const res = await DeleteInquiryService(activeItem && activeItem.inquiryId )
  
    if (!(res && res.status && res.status !== 200)) {
        showSuccess(t(`${translationPath}delete-inquiry-succes`));
        close() ;
        onSave();
    } else showError(t(`${translationPath}delete-inquiry-failed`));
    setIsLoading(false);
};



  return (
    <DialogComponent
        titleText='confirm-message'
        saveText={t(`${translationPath}confirm`)}
        SmothMove
        saveType='button'
        maxWidth='sm'
        dialogContent={(
          <div className='d-flex-column-center'>
            <Spinner isActive={isLoading} isAbsolute />
            <span className='mdi mdi-close-octagon c-danger mdi-48px' />
            <span className='fz-18px fw-bold'>
              {`${`${t(`${translationPath}are-you-sure-to-delete-this-inquiry`)}` || ''}`}

              <span className='d-flex-center  fz-22px fw-bold mt-2'>
                {' '}
               {t(`${translationPath}inquiryId`)}
                {' '}
                {' '}
                {' '}
                (
                {' '}
                {' '}
                {' '}
                {' '}
                {' '}
                {( activeItem && activeItem.inquiryId) }
                {' '}
                {' '}
                {' '}
                )
                {' '}
              </span>

            </span>
          </div>
        )}
        saveClasses='btns theme-solid bg-danger w-100 mx-2 mb-2'
        isOpen={true}
        onSaveClicked={()=> deleteHandler()}
        onCloseClicked={() =>  close()}
        onCancelClicked={() => close() }
        parentTranslationPath={parentTranslationPath}
        translationPath={translationPath}
      />

  );
};
